import { applyBasePrimeCostPrices } from "../utils/applyBasePrimeCostPrices";

function formatStickerNames(stickerNames: any): string {
  if (!stickerNames || !Array.isArray(stickerNames) || stickerNames.length === 0) {
    return "";
  }
  return stickerNames
    .map((item: any) => (item && item.name ? item.name : ""))
    .filter(Boolean)
    .join(", ");
}

export function flattenChildrenTree(
  tree: any[],
  expandedProductIds: Record<string | number, boolean> = {}
): any[] {
  const rows: any[] = [];

  (tree || []).forEach((product: any) => {
    const containers = product.children || [];
    const hasContainers = containers.length > 0;

    rows.push({
      ...product,
      type: "product",
      depth: 0,
      hasContainers,
      containerCount: containers.length
    });

    if (expandedProductIds[product.id]) {
      containers.forEach((container: any) => {
        rows.push({
          ...container,
          type: "container",
          depth: 1,
          parentProductId: product.id
        });
      });
    }
  });

  return rows;
}

export function buildChildrenTree(documents: any[]): any[] {
  return (documents || []).map((doc: any) => {
    const containers = (doc.children || []).map((item: any) => ({
      ...item,
      type: "container",
      name: item.name || item.container_name || "-",
      code: item.code || item.sku_mixcart || item.code_1c || "",
      sticker: formatStickerNames(item.sticker_names),
      product_name: doc.name
    }));

    return applyBasePrimeCostPrices({
      ...doc,
      type: "product",
      name: doc.name || doc.product_name || "-",
      code: doc.code || "",
      sticker: "",
      children: containers
    });
  });
}
